import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  ChannelTotalTransactionAmountDetailsResponseError,
  ChannelTotalTransactionAmountDetailsResponseOK,
  GetChannelTotalTransactionAmountDetailsRequestPayload
} from '@repositories/api/dashboard.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetChannelTotalTransactionAmountDetailsRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetChannelMonthlyTotalTransactionAmountDetailsQuery<
  Data extends ChannelTotalTransactionAmountDetailsResponseOK,
  ErrorResponse extends ChannelTotalTransactionAmountDetailsResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.DASHBOARD.GET_CHANNEL_MONTHLY_TOTAL_TRANSACTION_AMOUNT_DETAILS>
>) {
  return useQuery({
    queryKey: QUERY_KEY.DASHBOARD.GET_CHANNEL_MONTHLY_TOTAL_TRANSACTION_AMOUNT_DETAILS({
      queryParams
    }),
    queryFn: () => {
      return ApiRepository.dashboard.getChannelMonthlyTotalTransactionAmountDetails({
        queryParams
      });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetChannelMonthlyTotalTransactionAmountDetailsQuery };
